import { Component, input } from '@angular/core';

@Component({
  selector: 'app-logo',
  standalone: true,
  template: `
    <svg [attr.width]="size()" [attr.height]="size()" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" class="text-primary-600 dark:text-primary-400">
      <!-- Root span -->
      <circle cx="2.5" cy="4" r="2" fill="currentColor"/>
      <rect x="6" y="3" width="12" height="2" rx="1" fill="currentColor"/>
      <!-- Tree trunk -->
      <line x1="2.5" y1="6" x2="2.5" y2="17" stroke="currentColor" stroke-width="1.2" stroke-opacity="0.35"/>
      <!-- Child 1 -->
      <line x1="2.5" y1="10.5" x2="5" y2="10.5" stroke="currentColor" stroke-width="1.2" stroke-opacity="0.35"/>
      <circle cx="6.5" cy="10.5" r="1.5" fill="currentColor" opacity="0.8"/>
      <rect x="9.5" y="9.5" width="8" height="2" rx="1" fill="currentColor" opacity="0.8"/>
      <!-- Child 2 -->
      <line x1="2.5" y1="16.5" x2="5" y2="16.5" stroke="currentColor" stroke-width="1.2" stroke-opacity="0.35"/>
      <circle cx="6.5" cy="16.5" r="1.5" fill="currentColor" opacity="0.55"/>
      <rect x="9.5" y="15.5" width="10" height="2" rx="1" fill="currentColor" opacity="0.55"/>
    </svg>
  `,
})
export class LogoComponent {
  size = input<number>(20);
}
